import { Text } from '@qga/roo-ui/components';

import Skeleton from '@shared/v2/components/Skeleton/Skeleton';

import Button from '@/components/Button/Button';
import { useOfferModalControls } from '@/v2/components/pages/PackageView/contexts/OfferModalControlsContext';
import { useRoomOptionsData } from '@/v2/components/pages/PackageView/contexts/RoomOptionsContext';

const UpgradeButton = () => {
  const { upgradeOffer } = useRoomOptionsData() || {};
  const { openOtherOptionModal } = useOfferModalControls();

  if (!upgradeOffer) {
    return null;
  }

  return (
    <Skeleton.Button>
      <Button
        px={3}
        py="10px"
        variant="primary"
        outline
        onClick={openOtherOptionModal}
      >
        <Text display="block" lineHeight="1.5" fontWeight="bold" fontSize="sm">
          1 Other Option
        </Text>
      </Button>
    </Skeleton.Button>
  );
};

export default UpgradeButton;
